export function classIf (condition, classes) {
    return condition ? ` ${classes}`: '';
}
